import { createContext, useContext, useState, useCallback } from 'react';
import niaAvatar from '../assets/figma/profile/nia-avatar.png';
import alexPortrait from '../assets/figma/profile/alex-mobile-portrait.png';
import bloggerAvatar from '../assets/figma/player/intro-blogger-profile.png';
import memory01 from '../assets/figma/dashboard/memory-01.jpg';
import memory02 from '../assets/figma/dashboard/memory-02.jpg';

const NotificationContext = createContext();

const INITIAL_NOTIFICATIONS = [
  {
    id: 1,
    type: 'like',
    user: 'Gineb, Daisy',
    line: 'and 18 others liked your post',
    avatarImages: [niaAvatar, alexPortrait],
    avatarStack: true,
    date: 'Sep 02, 2025 - 09:15:30',
    unread: false,
    targetPath: '/player/1?panel=likes',
  },
  {
    id: 2,
    type: 'comment',
    user: 'Alicia',
    line: 'commented on your post',
    avatarImage: alexPortrait,
    date: 'Sep 02, 2025 - 09:15:30',
    unread: true,
    targetPath: '/player/1?panel=comments',
  },
  {
    id: 3,
    type: 'like',
    title: 'New Like',
    description: 'Albert, and 40 others liked your post',
    avatarImage: bloggerAvatar,
    previewImage: memory01,
    date: 'Aug 28, 2025 - 02:05:10',
    unread: false,
    targetPath: '/player/1?panel=likes',
  },
  {
    id: 4,
    type: 'memory',
    user: 'Brian',
    line: 'just created a Memory from your most recent collectable!',
    avatarImage: bloggerAvatar,
    date: 'Sep 01, 2025 - 03:11:20',
    unread: false,
    targetPath: '/player/1?panel=memory',
  },
  {
    id: 5,
    type: 'collect',
    user: 'Ashley',
    line: 'collected your "Echoes, Live" from your recent post',
    avatarImage: niaAvatar,
    date: 'Sep 01, 2025 - 03:11:20',
    unread: false,
    targetPath: '/player/1',
  },
  {
    id: 6,
    type: 'like',
    line: 'Larry95, Jim and 5 others commented on your post',
    avatarImages: [niaAvatar, alexPortrait],
    avatarStack: true,
    previewImage: memory02,
    date: 'Sep 02, 2025 - 09:15:30',
    unread: false,
    targetPath: '/player/1?panel=comments',
  },
];

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState(INITIAL_NOTIFICATIONS);

  const unreadCount = notifications.filter(n => n.unread).length;

  const markAllRead = useCallback(() => {
    setNotifications(prev => prev.map(n => ({ ...n, unread: false })));
  }, []);

  const addNotification = useCallback((notification) => {
    setNotifications(prev => [{ ...notification, unread: true }, ...prev]);
  }, []);

  return (
    <NotificationContext.Provider value={{ notifications, unreadCount, markAllRead, addNotification }}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotifications() {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error('useNotifications must be used within NotificationProvider');
  return ctx;
}
